import axios from 'axios';
import router from './router'
import Vue from 'vue'
import ElementUI from 'element-ui'
import {
  Loading,
  MessageBox
} from 'element-ui';
import {
  getCookie,
  checkCookie,
  delCookie
} from '../utils/cookie.js';
import {
  cosh
} from 'core-js/core/number';
// 环境
var root = process.env.VUE_APP_PRD_BASE_API;
let loading;
const startLoading = () => {
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.7)'
  });
};
const endLoading = () => {
  loading.close();
};
const Alert = axios.interceptors.request.use(config => {
  config.nol = config.nol == undefined ? true : false
  if (config.nol) {
    startLoading();
  }

  config.url = (root || '') + config.url
  if (config.url === '/url/v1/login/reg' || config.url === '/url/v1/login/login') {} else {
    if (sessionStorage.id) {
      config.headers = {
        Authorization: sessionStorage.id
      }
    }
  }
  return config
})
axios.interceptors.response.use(
  response => {
    if (response.data.errno == 999) {
      router.replace('/')
    }
    if (response.data.code == 200) {
      endLoading();
    }
    if (response.data.code == 500) {
      endLoading();
    }
    return response
  },
  error => {
    return error
  }
)
//

//全局前置守卫
router.beforeEach((to, from, next) => {
  if (checkCookie('id') && !sessionStorage.id) {
    window.sessionStorage['id'] = getCookie('id')
    window.sessionStorage['name'] = getCookie('name')
    window.sessionStorage['party_id'] = getCookie('party_id')
    window.sessionStorage['party_name'] = getCookie('party_name')
    window.sessionStorage['tips'] = getCookie('tips')
    window.sessionStorage['reg_type'] = getCookie('reg_type')
  } else if (!checkCookie('id') && sessionStorage.id) {
    sessionStorage.clear()
  } else if ((sessionStorage.id && checkCookie('id')) && sessionStorage.id != getCookie('id')) {
    sessionStorage.clear();
    window.sessionStorage['id'] = getCookie('id')
    window.sessionStorage['name'] = getCookie('name')
    window.sessionStorage['party_id'] = getCookie('party_id')
    window.sessionStorage['party_name'] = getCookie('party_name')
    window.sessionStorage['tips'] = getCookie('tips')
    window.sessionStorage['reg_type'] = getCookie('reg_type')
    // delCookie(['id','name','party_id','party_name','tips','reg_type']);
    // MessageBox.alert('登录异常请重新登录', "提示", {
    //   confirmButtonText: "确定",
    //   callback: action => {
    //     next({path: '/login'})
    //   }
    // })
  }
  // 判断此跳转路由是否开启登录验证
  if (to.meta.requireAuth) {
    if (sessionStorage.id) {
      if (sessionStorage.reg_type == 3) {
        if (to.name == "personalZte") {
          next()
        } else if (to.name == "socialcredit") {
          MessageBox.alert('个人用户不支持此模块！', '提示', {
            confirmButtonText: "确定",
            callback: action => {}
          })
        } else {
          MessageBox.alert('个人用户不支持此模块！', '提示', {
            confirmButtonText: "确定",
            callback: action => {}
          })
        }
      } else {
        next()
      }
    } else {
      MessageBox.alert('请先登录！', '提示', {
        confirmButtonText: "确定",
        callback: action => {
          next({
            path: '/login',
            query: {
              redirect: to.fullPath
            }
          })
        }
      })

    }
  } else {
    next()
  }
})

export default axios
